import React from "react";
// Existing imports
import housekeeping from "../assets/housekeeping.png";
import pool from "../assets/pool.png";
import drycleaning from "../assets/drycleaning.png";
import technical from "../assets/technical.png";
import landscaping from "../assets/landscaping.png";
import fooddelivery from "../assets/fooddelivery.png";
import grocery from "../assets/grocery.png";
import petgrooming from "../assets/petgrooming.png";
import medical from "../assets/medical.png";
import barber from "../assets/barber.png";
import pharmacy from "../assets/pharmacy.png";
import cinema from "../assets/cinema.png";
import events from "../assets/events.png";
import carservice from "../assets/carservice.png";
import driver from "../assets/driver.png";

// 🆕 New imports
import vrhome from "../assets/vrhome.png";
import smarthome from "../assets/smarthome.png";
import repair from "../assets/repair.png";
import solar from "../assets/solar.png";
import app from "../assets/app.png";

export default function Services() {
  const services = [
    {
      img: housekeeping,
      title: "Housekeeping",
      text: "Daily or weekly cleaning tailored to your needs.",
    },
    {
      img: pool,
      title: "Pool Maintenance",
      text: "Professional pool cleaning and water care.",
    },
    {
      img: drycleaning,
      title: "Dry Cleaning",
      text: "Premium laundry and dry-clean delivery service.",
    },
    {
      img: technical,
      title: "Household Services",
      text: "On-demand repairs and technical support.",
    },
    {
      img: landscaping,
      title: "Private Landscaping",
      text: "Garden design and full lawn care.",
    },
    {
      img: fooddelivery,
      title: "Food & Grocery Delivery",
      text: "Order meals or groceries straight to your home.",
    },
    {
      img: petgrooming,
      title: "Pet Grooming",
      text: "At-home grooming or nearby clinic care.",
    },
    {
      img: medical,
      title: "Medical Services",
      text: "Partnership with Reference Clinic for residents.",
    },
    {
      img: barber,
      title: "Barber & Makeup",
      text: "In-home styling and beauty services.",
    },
    {
      img: pharmacy,
      title: "Online Pharmacy",
      text: "Medicines and prescriptions with home delivery.",
    },
    {
      img: cinema,
      title: "Outdoor Mini Cinema",
      text: "Private open-air movie nights for families.",
    },
    {
      img: events,
      title: "Event Ceremonies",
      text: "Birthday, engagement, and wedding celebrations.",
    },
    {
      img: carservice,
      title: "Car Services",
      text: "Cleaning, fueling, and delivery on request.",
    },
    {
      img: driver,
      title: "Driver Service",
      text: "Professional chauffeur service on demand.",
    },

    // 🆕 Newly added modern tech & lifestyle services
    {
      img: vrhome,
      title: "VR Home Experience",
      text: "Personalize your villa’s interior through an immersive VR experience.",
    },
    {
      img: smarthome,
      title: "Smart Home Systems",
      text: "Control lighting, climate, and security with a single smart system.",
    },
    {
      img: repair,
      title: "Villa Interior Repair",
      text: "Request professional interior repair and maintenance.",
    },
    {
      img: solar,
      title: "Solar Panels",
      text: "Ordering solar panels for sustainable living and EV charging.",
    },
    {
      img: app,
      title: "Mobile Application",
      text: "Order all residence services easily via our mobile app.",
    },
  ];

  return (
    <section id="services">
      <h2>Exclusive Extra Services</h2>

      <div className="services-intro-modern reveal">
        <div className="intro-left">
          <p>
            Each villa includes <strong>4 resident membership cards</strong>{" "}
            that grant access to 24-hour concierge support and exclusive
            discounts at nearby
            <strong> Gazelli</strong> and <strong>Sheraton Spa</strong>.
          </p>
          <p>
            Residents can easily order additional services via our mobile app,
            with secure payments for each request.
          </p>
        </div>

        <div className="intro-right">
          <p>
            Guests of residents are welcome to stay at the community guest house
            and enjoy all on-demand services using a member’s card.
          </p>
          <p>
            This system ensures seamless, premium living where comfort and
            convenience meet modern technology.
          </p>
        </div>
      </div>

      <div className="services-divider"></div>

      <div className="services-grid">
        {services.map((service, i) => (
          <div key={i} className="service-item reveal">
            <img src={service.img} alt={service.title} />
            <div className="service-text">
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
